module.exports = __webpack_public_path__ + "static/media/vector-square.b03fc822.svg";